import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium',
  {
    variants: {
      tone: {
        neutral: 'bg-[var(--fl-surface-subtle)] text-[var(--fl-text-2)]',
        primary: 'bg-[var(--fl-primary-subtle)] text-[var(--fl-primary-text)]',
        warning: 'bg-[var(--fl-warning-bg)] text-[var(--fl-warning-text)]',
        expense: 'bg-[var(--fl-expense-bg)] text-[var(--fl-expense)]',
        error: 'bg-[var(--fl-error-bg)] text-[var(--fl-error-dark)]',
      },
    },
    defaultVariants: {
      tone: 'neutral',
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, tone, ...props }, ref) => {
    return <span ref={ref} className={cn(badgeVariants({ tone }), className)} {...props} />
  }
)
Badge.displayName = 'Badge'

export { Badge, badgeVariants }
